import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const eklok = (token, id) =>
  Manager.client(token).get(`${Endpoints.eklok.ekloks}${id}/`);
const commandList = (token, id) =>
  Manager.client(token).get(`${Endpoints.mobileFrame.commandList}${id}`);
const eventStatusList = (token, id) =>
  Manager.client(token).get(`${Endpoints.mobileFrame.eventStatusList}${id}`);
const stopAllActionEvent = (token, values) =>
  Manager.client(token).post(Endpoints.mobileFrame.stopAllActionEvent, values);
const setActionEvent = (token, values) =>
  Manager.client(token).post(Endpoints.mobileFrame.setActionEvent, values);
const getSoundBlockStatus = (token, id) =>
  Manager.client(token).get(
    `${Endpoints.mobileFrame.getSoundBlockStatus}${id}`,
  );
const setSoundBlockStatus = (token, values) =>
  Manager.client(token).post(Endpoints.mobileFrame.setSoundBlockStatus, values);
const assistanceData = (token, id) =>
  Manager.client(token).get(`${Endpoints.mobileFrame.assistanceData}${id}`);
const calendarEventData = (token, body) =>
  Manager.client(token).post(Endpoints.mobileFrame.calendarEventData, body);
const deleteCalendarEventData = (token, body) =>
  Manager.client(token).post(
    Endpoints.mobileFrame.deleteCalendarEventData,
    body,
  );
const addCalendarEventData = (token, body) =>
  Manager.client(token).post(Endpoints.mobileFrame.addCalendarEventData, body);

const setEklokLineStatus = (token, body) =>
  Manager.client(token).post(Endpoints.mobileFrame.setEklokLineStatus, body);

export const Request = {
  eklok,
  commandList,
  eventStatusList,
  stopAllActionEvent,
  setActionEvent,
  getSoundBlockStatus,
  setSoundBlockStatus,
  assistanceData,
  calendarEventData,
  deleteCalendarEventData,
  addCalendarEventData,
  setEklokLineStatus,
};
